import React, { Component, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Col, Row } from 'reactstrap';

const FormRepresent = ({ index,
    dataCompanion,
    errors,
    handlerDocumentNumber,
    handlerTypeCompanion,
    handlerName,
    enable,
    handlerFirstTelephone,
    handlerSecondTelephone,
    handlerRelationship
}) => {
    console. log("-----------------------------------", index)
    console. log("----------------------------------- errors", errors)
    const isThereErrorInIndex = (errors !== null && errors !== undefined && (errors[index] !== undefined && errors[index]!== null ))
    return (<Fragment>

        <Col md={2}>
            <FormControl
                style={{ margin: 10, width: 200 }}
                error={isThereErrorInIndex ? (errors[index].hasOwnProperty("relationship") ? errors[index].relationship !== "" : false) : false}
            >
                <InputLabel id="relationship-status-select-label">Parentesco</InputLabel>
                <Select
                    labelId="relationship-select-label"
                    id="id-simple-select"
                    defaultValue={null}
                    value={dataCompanion.relationship}
                    disabled={enable}
                    onChange={(event) => {
                        handlerRelationship(index, event.target.value);
                    }}
                    error={isThereErrorInIndex ? (errors[index].hasOwnProperty("relationship") ? errors[index].relationship !== "" : false) : false}
                >
                    <MenuItem key={0} value={'otro'}>OTRO</MenuItem>
                    <MenuItem key={1} value={'Padre'}>PADRE</MenuItem>
                    <MenuItem key={2} value={'madre'}>MADRE</MenuItem>
                    <MenuItem key={3} value={'abuelo'}>ABUELO</MenuItem>
                    <MenuItem key={4} value={'conyuge'}>CONYUGE</MenuItem>
                </Select>
                <FormHelperText>{isThereErrorInIndex ? errors[index].relationship : null}</FormHelperText>
            </FormControl>
        </Col>

        <Col md={2}>
            <TextField
                required
                style={{ margin: 10, width: 200 }}
                id="document-number-standard-required"
                label="N° de documento"
                type="number"
                disabled={enable}
                value={dataCompanion.number}
                onChange={(e) => {
                    handlerDocumentNumber(index, e.target.value);
                }}
                error={isThereErrorInIndex ? (errors[index].hasOwnProperty("number") ? errors[index].number !== "" : false) : false}
                helperText={isThereErrorInIndex ? errors[index].number : null}
            />
        </Col>

        <Col md={2}>
            <TextField
                required
                style={{ margin: 10, width: 200 }}
                id="name-standard-required"
                label="nombre completo"
                type="text"
                value={dataCompanion.name}
                onChange={(e) => {
                    handlerName(index, e.target.value);
                }}
                disabled={enable}
                error={isThereErrorInIndex ? (errors[index].hasOwnProperty("name") ? errors[index].name !== "" : false) : false}
                helperText={isThereErrorInIndex ? errors[index].name : null}
            />
        </Col>

        <Col md={2}>
            <TextField
                required
                style={{ margin: 10, width: 200 }}
                id="telephone-standard-required"
                label="1° Teléfono "
                type="number"
                value={dataCompanion.firstTelephone}
                onChange={(e) => {
                    handlerFirstTelephone(index, e.target.value);
                }}
                disabled={enable}
                error={isThereErrorInIndex ? (errors[index].hasOwnProperty("firstTelephone") ? errors[index].firstTelephone !== "" : false) : false}
                helperText={isThereErrorInIndex ? errors[index].firstTelephone : null}
            />
        </Col>

        <Col md={2}>
            <TextField
                style={{ margin: 10, width: 200 }}
                id="telephone-standard-required"
                label="2° Teléfono "
                type="number"
                value={dataCompanion.secondTelephone}
                disabled={enable}
                onChange={(e) => {
                    handlerSecondTelephone(index, e.target.value);
                }}
            />
        </Col>
    </Fragment>)
}

export default FormRepresent;